import type { AppError } from '../../api/contract';

export function toSafePartnerGameError(
  cause: unknown,
  t: (key: string) => string,
  fallbackMessage: string,
): Pick<AppError, 'message' | 'requestId'> {
  const code = readStringProperty(cause, 'code');
  const requestId = readStringProperty(cause, 'requestId');
  const messageKey =
    code === 'PARTNER_GAME_CURRENCY_CONFLICT'
      ? 'games.partner.errors.currencyConflict'
      : code === 'PARTNER_GAME_CONFLICT'
        ? 'games.partner.errors.conflict'
        : code === 'PARTNER_GAME_NOT_FOUND'
          ? 'games.partner.errors.notFound'
          : code === 'PARTNER_GAME_UNAVAILABLE'
            ? 'games.partner.errors.unavailable'
            : code === 'GAME_NOT_FOUND'
              ? 'games.partner.errors.gameNotFound'
              : code === 'PARTNER_NOT_FOUND'
                ? 'games.partner.errors.partnerNotFound'
                : null;

  return {
    message: messageKey === null ? fallbackMessage : t(messageKey),
    requestId,
  };
}

function readStringProperty(value: unknown, property: string): string | null {
  if (typeof value !== 'object' || value === null || !(property in value)) return null;
  const propertyValue = (value as Record<string, unknown>)[property];
  return typeof propertyValue === 'string' ? propertyValue : null;
}
